const translationKeys = {
  HOME_HEADER_TITLE: "home.header.title",

  ERROR_COPY: "Texts.token-fund-holdings.error-copy",
  ERROR_HAS_OCCURRED: "Texts.token-fund-holdings.error-has-occurred",
  ERROR_PAGE_CTA: "Texts.token-fund-holdings.error-page-cta",
  ERROR_PAGE_ALERT: "Texts.token-fund-holdings.error-page-alert",
  ERROR_PAGE_SUBTITLE_WITH_CODE:
    "Texts.token-fund-holdings.error-page-subtitle-with-code",
  ERROR_PAGE_SUBTITLE: "Texts.token-fund-holdings.error-page-subtitle",
  ERROR_PAGE_TITLE: "Texts.token-fund-holdings.error-page-title",
  ERROR_PAGE_CODE_COPIED: "Texts.token-fund-holdings.error-page-code-copied",

  TEXT_HOLDINGS_DOWNLOAD_PDF: "Texts.fund-holdings.download_button_label_pdf",
  TEXT_HOLDINGS_DOWNLOAD_CSV: "Texts.fund-holdings.download_button_label_csv",
  TEXT_HOLDINGS_DOWNLOAD_MODAL_TITLE:
    "Texts.fund-holdings.download_modal.title",
  TEXT_HOLDINGS_DOWNLOAD_MODAL_TEXT: "Texts.fund-holdings.download_modal.text",
  TEXT_HOLDINGS_DOWNLOAD_MODAL_TEXT_SECONDARY:
    "Texts.fund-holdings.download_modal.text_secondary",
  TEXT_HOLDINGS_DOWNLOAD_ERROR: "Texts.fund-holdings.download_modal.error",
  TEXT_HOLDINGS_TABLE_DOWNLOAD_BUTTON: "Texts.fund-holdings.table_cta",
} as const;

export default translationKeys;

export type TranslationKey =
  (typeof translationKeys)[keyof typeof translationKeys];
